import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { CardDashboard, CardContent, Badge } from '@percent/lemonade'
import { getDate } from '@percent/admin-dashboard/common/utility/getDate'
import type { Account } from '@percent/domain/iam'

type AdminCardProps = {
  account: Account
  action?: ReactNode
}

export function AdminCard({ account, action }: AdminCardProps) {
  const { t } = useTranslation()
  const dash = '-'

  return (
    <CardDashboard title={t('memberProfile.admin')} headingLevel="h4" action={action}>
      <CardContent title={t('memberProfile.admin')} testId="admin-status">
        {account.admin ? (
          <Badge variant="positive" icon="approve">
            {t('status.yes')}
          </Badge>
        ) : (
          dash
        )}
      </CardContent>
      {account.admin && (
        <CardContent title={t('memberProfile.adminSince')} testId="admin-since">
          {getDate(account.admin) || dash}
        </CardContent>
      )}
    </CardDashboard>
  )
}
